import React, { forwardRef, useEffect, useMemo } from 'react'
import { castArray, isArray } from 'lodash-es'
import { Input } from '@ow/comps'
import Select from './Select'

const Render = function ({ opts = {}, onChange, formControl, value }) {
  const { slug, selects, etc, multiple, defaultValue } = opts
  const { setValue, getValues } = formControl || {}
  const values = isArray(value) ? value : [value]

  const setOtherSlug = (nextVals) => {
    const slugName = slug + '_otherSelects'
    const curValuesArr = getValues(slugName) || []
    const nextValuesArr = nextVals.filter((val) => val.needInput)
    if (nextValuesArr.length === 0) {
      setValue(slugName, [])
    } else {
      const leftArr = curValuesArr.filter((curVal) =>
        nextValuesArr.some((item) => item.slug === curVal.slug)
      )
      const addArr = nextValuesArr.filter((item) =>
        curValuesArr.every((curVal) => curVal.slug !== item.slug)
      )
      setValue(
        slugName,
        leftArr.concat(addArr).sort((a, b) => a.value - b.value)
      )
    }
  }

  const updateValue = (e) => {
    if (e) {
      const selected = multiple ? e : [e]
      const selectValues = selected.map((v) => v.slug)
      setOtherSlug(selected)
      onChange(selectValues)
    } else {
      onChange(multiple ? [] : null)
    }
  }

  const onTextChange = (e, item) => {
    const slugName = slug + '_otherSelects'
    const currentOtherSlug = getValues(slugName) || []
    const finalOtherSlug = currentOtherSlug.map((selectedItem) => {
      if (selectedItem.slug === item.slug) {
        selectedItem.inputValue = e.target.value.trim()
      }
      return selectedItem
    })
    setValue(slugName, finalOtherSlug)
    setValue(slug, getValues(slug))
  }

  const options = useMemo(() => {
    return (selects || []).map((v, index) => {
      return {
        ...v,
        value: index,
        label: v.title,
      }
    })
  }, [value, selects])

  const selectValues = useMemo(() => {
    return options.filter((v) => values.includes(v.slug)).map((v) => v.value)
  }, [options])

  const inputSelects = useMemo(() => {
    if (!etc) return []
    // 兼容历史的单选内容，将其他选项存入 slug_otherSelects，格式为 json
    const slugName = `${slug}_otherSelects`
    return getValues(slugName) || []
  }, [value])
  useEffect(() => {
    // 初始化，将原来的单条数据，进行格式化处理，并存入 _otherSelects
    const selectSlugName = `${slug}_otherSelect`
    const selectsSlugName = `${slug}_otherSelects`
    const otherVal = getValues(selectSlugName)
    const othersVal = getValues(selectsSlugName)
    if (!othersVal && otherVal) {
      const selectItem = selects.filter((sel) => sel.needInput)
      selectItem[0].inputValue = otherVal
      setValue(selectsSlugName, selectItem)
      setValue(selectSlugName, '')
    }
  }, [])

  useEffect(() => {
    if (defaultValue) {
      onChange(castArray(defaultValue))
    }
  }, [defaultValue])

  return (
    <div
      className={
        inputSelects.length > 0
          ? 'w-full flex flex-col'
          : 'w-full flex items-center'
      }
    >
      <Select
        slug={slug}
        onlyShow={opts.onlyShow}
        options={options}
        selectValues={selectValues}
        onChange={updateValue}
        opts={opts}
      />
      <div className="flex flex-col">
        {inputSelects.map((item) => {
          return (
            <div
              className="flex flex-row h-14 items-center flex-1 mt-1"
              key={`inputSelect-${slug}-${item.slug}`}
            >
              <span className="mr-4">{item.title}</span>
              <div className="w-2/5">
                <Input
                  type={item.inputType}
                  name={item.slug}
                  placeholder="请输入"
                  defaultValue={item.inputValue}
                  onChange={(e) => onTextChange(e, item)}
                  style={{ width: '100%' }}
                  value={item.inputValue}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default forwardRef(Render)
